import createAsyncActionType from "../../../utilities/createAsyncActionType";

export const GET_ORGANIZATION_INFO = createAsyncActionType(
  "GET_ORGANIZATION_INFO"
);
export const GET_ORGANIZATION_LOGIN = createAsyncActionType(
  "GET_ORGANIZATION_LOGIN"
);
export const UPDATE_ORGANIZATION_INFO = createAsyncActionType(
  "UPDATE_ORGANIZATION_INFO"
);
export const UPDATE_ORGANIZATION_LOGIN = createAsyncActionType(
  "UPDATE_ORGANIZATION_LOGIN"
);
export const CLEAR_ORGANIZATION_INFO = "CLEAR_ORGANIZATION_INFO";



// WEBPACK FOOTER //
// ./src/features/organization/types/getOrganizationInfo.js